import { Language } from '@argenta/react-ui';

export const getLanguageFromUrlParams = (url: string): Language => {
  const parameters = url.split('/');
  const supportedLanguages: string[] = ['nl', 'fr'];
  if (parameters && parameters.length >= 4 && supportedLanguages.includes(parameters[3])) {
    return parameters[3] as Language;
  }
  return 'nl';
};
